export const floatlabel = {
  root: {
    color: "{typography.input.placeholder.color}",
    focusColor: "{typography.input.label.color}",
    activeColor: "{typography.input.label.color}",
    invalidColor: "{form.field.float.label.invalid.color}",
    transitionDuration: "{form.field.transition.duration}",
    positionX: "{form.field.padding.x}",
    positionY: "{form.field.padding.y}",
    fontWeight: "{typography.input.placeholder.font.weight}",
    active: {
      fontSize: "{typography.input.label.font.size}",
      fontWeight: "{typography.input.label.font.weight}",
    },
  },
  // over: {
  //   active: {
  //     top: "-1.25rem",
  //   },
  // },
  in: {
    input: {
      paddingTop: "{padding.24}",
      paddingBottom: "{padding.8}",
    },
    active: {
      top: "{form.field.padding.y}",
    },
  },
  // on: {
  //   borderRadius: "{border.radius.2}",
  //   active: {
  //     background: "{form.field.background}",
  //     padding: "0 0.125rem",
  //   },
  // },
  extend: {
    ui: {
      root: {
        fontLeading: "20px",
        active: {
          fontLeading: "1",
        },
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-floatlabel label {
      line-height: ${dt("floatlabel.ui.font.leading")};
    }

    .p-floatlabel-in:has(input:focus) label,
    .p-floatlabel-in:has(input.p-filled) label,
    .p-floatlabel-in:has(input:-webkit-autofill) label,
    .p-floatlabel-in:has(textarea:focus) label,
    .p-floatlabel-in:has(textarea.p-filled) label,
    .p-floatlabel-in:has(.p-inputwrapper-focus) label,
    .p-floatlabel-in:has(.p-inputwrapper-filled) label {
      line-height: ${dt("floatlabel.ui.active.font.leading")};
    }

    .p-floatlabel-in:has(input:not(.p-datepicker-input):placeholder-shown) label,
    .p-floatlabel-in:has(textarea:placeholder-shown) label {
      top: ${dt("floatlabel.in.active.top")};
      line-height: ${dt("floatlabel.ui.active.font.leading")};
      color: ${dt("floatlabel.active.color")};
      transform: translateY(0);
      font-size: ${dt("floatlabel.active.font.size")};
      font-weight: ${dt("floatlabel.label.active.font.weight")};
    }

    .p-floatlabel-in .p-multiselect-label-container {
      padding-block-end: ${dt("multiselect.padding.y")};
      padding-inline: ${dt("multiselect.padding.x")};
    }

    .p-floatlabel-in .p-multiselect-display-chip .p-multiselect-label-container {
      padding-block-start: calc(${dt("floatlabel.in.input.padding.top")} - (${dt("multiselect.padding.y")} / 2));
      padding-block-end: calc(${dt("multiselect.padding.y")} / 2);
    }

    .p-floatlabel-in .p-multiselect-label {
      padding: 0;
    }

    .p-floatlabel-in .p-select + label {
      padding-inline-end: ${dt("select.dropdown.width")};
    }

    .p-floatlabel-in .p-multiselect + label {
      padding-inline-end: ${dt("multiselect.dropdown.width")};
    }

    .p-floatlabel-in p-datepicker,
    .p-floatlabel-in .p-datepicker.p-inputwrapper {
      width: 100%;
    }

    .p-floatlabel-in .p-select:has(.p-tag) .p-select-label {
      padding-block-start: calc(${dt("floatlabel.in.input.padding.top")} - (${dt("select.padding.y")} - ${dt("select.ui.padding.y.with.tag")}));
    }

    /* Fix for selectbutton and radiobuttons inside floatlabel */
    .p-floatlabel-in:has(.p-selectbutton) > label,
    .p-floatlabel-in:has(.p-radiobutton) > label {
      top: ${dt("floatlabel.in.active.top")};
      font-size: ${dt("floatlabel.active.font.size")};
      font-weight: ${dt("floatlabel.label.active.font.weight")};
      color: ${dt("floatlabel.active.color")};
      transform: translateY(0);
      line-height: 1;
      z-index: 1;
    }

    .p-floatlabel-in .p-selectbutton,
    .p-floatlabel-in:has(.p-radiobutton) > div:first-child {
      margin-top: ${dt("floatlabel.in.input.padding.top")};
    }
  `,
};
